export interface IUIState {
    username: string | null;
}

export const initialUIState: IUIState = {
    username: null
};